import styled from 'styled-components'
import PropTypes from 'prop-types'

const UnorderListStyled = styled.ul`
  color: ${({ color }) => (color || 'var(--baseNeutral)')};
  padding: ${({ padding }) => padding};
  li {
    margin: ${({ gap }) => `${gap}px 0`};
    font-weight: ${({ weight }) => weight};
    font-size: 16px;
    line-height: 24px;
    position: relative;
    &::before{
      position: absolute;
      width: ${({ bulletSize }) => `${bulletSize}px`};
      height: ${({ bulletSize }) => `${bulletSize}px`};
      top: 5px;
      ${({ bulletCenter }) => bulletCenter && `
        top: 0px;
        margin: auto 0;
        bottom: 0px;
      `};
      left: -16px;
      content: '';
      display: block;
      background-color: var(--secondary);
      border-radius: 50%;
    }
  }
`

export function UnorderList({
  items, gap, padding, weight, bulletSize, bulletCenter, keySufix, ...otherProps
}) {
  return (
    <UnorderListStyled
      gap={gap}
      bulletSize={bulletSize}
      bulletCenter={bulletCenter}
      padding={padding}
      weight={weight}
      {...otherProps}
    >
      {items.map((item) => (
        <li key={`list-${item}`}>{item}</li>
      ))}
    </UnorderListStyled>
  )
}

UnorderList.defaultProps = {
  bulletCenter: false,
  gap: 16,
  padding: '0 16px',
  weight: '400',
  bulletSize: 12,
  key: 'unorder-list',
}

UnorderList.propTypes = {
  bulletCenter: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  gap: PropTypes.number,
  padding: PropTypes.string,
  weight: PropTypes.string,
  bulletSize: PropTypes.number,
  key: PropTypes.string,
}


export function OrderList({ items, gap }) {
  return (
    <UnorderListStyled gap={gap}>
      {items.map((item) => (
        <li>{item}</li>
      ))}
    </UnorderListStyled>
  )
}

OrderList.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.string,
  ).isRequired,
  gap: PropTypes.string.isRequired,
}
